module.exports = __webpack_public_path__ + "img/g3.0a74783b.png";